<template>
  <apexchart type="donut" :options="chartOptions" :series="series" :height="200"></apexchart>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    friend: {
      type: Number,
      default: 0
    },
    friendPercent: {
      type: Number,
      default: 0
    },
    nonFriend: {
      type: Number,
      default: 0
    },
    nonFriendPercent: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      series: [this.friend, this.nonFriend],
      chartOptions: {
        labels: ['Enter', 'Banner'],
        chart: {
          type: 'donut',
          height: '200px'
        },
        plotOptions: {
          pie: {
            donut: {
              size: '70%'
            }
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                height: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/Dashboard/LineFriendChart.vue